import React, { useEffect, useState } from 'react';

import { useTranslation } from '@crehana/i18n';

import { MainMenu, MainFooter, useMe } from '@crehana/web';

import {
  useBrowserIdle,
  useDisclosure,
  useIsClient,
} from '@crehana/react-hooks';

import ExitPopup from 'Shared/ExitPopup';

import HeroSection from './components/CourseFree/HeroSection';
import FeatureSection from './components/FeatureSection';
import CourseAgenda from './components/CourseAgenda';
import LiveBanner from './components/LiveBanner';
import EnrollmentDialog from './components/EnrollmentDialog';
import PhoneNumberDialog from './components/PhoneNumberDialog';
import { AppProps } from './types';
import useCourseAgenda from './hooks/useCourseAgenda';
import { enrollToCourse } from './utils';
import { FREE_COURSES_AMPLITUDE_PAGE_NAME } from './constants';

const App: React.FC<AppProps> = ({ course, isPtLanding }) => {
  const isClient = useIsClient();
  const [currentUrl, setCurrentUrl] = useState('');
  const { onOpen, isOpen, onClose } = useDisclosure();
  const { t } = useTranslation();
  const isIdle = useBrowserIdle();
  const [currentCourseEnrollmentUrl, setCurrentCourseEnrollmentUrl] =
    React.useState('');
  const [open, setOpen] = React.useState(false);
  const { courses, loadingAgenda, errorAgenda, refetchAgenda } =
    useCourseAgenda(!!isPtLanding);
  const { loading: loadingUser, me } = useMe();

  const onSuccessBasicDataForm = () => {
    enrollToCourse(currentCourseEnrollmentUrl);
  };

  useEffect(() => {
    setCurrentUrl(window.location.href);
  }, []);

  if (!isClient) return null;

  return (
    <div>
      <MainMenu
        // This landing doesn't support i18n per country, so we hardcoded the country prefix
        countryPrefix=""
        amplitudePageName={FREE_COURSES_AMPLITUDE_PAGE_NAME}
        customUrls={{
          login: `/entrar/?next=${currentUrl}`,
          register: `/onboarding/?nextUrl=${currentUrl}`,
        }}
      />
      <div>
        {course && (
          <HeroSection
            showPhoneNumberDialog={courseEnrollmentUrl => {
              setCurrentCourseEnrollmentUrl(courseEnrollmentUrl);
              onOpen();
            }}
            course={course}
          />
        )}
        <FeatureSection />
        <CourseAgenda
          loadingAgenda={loadingAgenda}
          errorAgenda={errorAgenda}
          courses={courses}
          setOpen={setOpen}
          user={me}
          refetchAgenda={refetchAgenda}
          showPhoneNumberDialog={courseEnrollmentUrl => {
            setCurrentCourseEnrollmentUrl(courseEnrollmentUrl);
            onOpen();
          }}
        />
        <LiveBanner />
        {open && <EnrollmentDialog open={open} setOpen={setOpen} />}
        {isOpen && (
          <PhoneNumberDialog
            isOpen={isOpen}
            onClose={() => {
              onClose();
              setCurrentCourseEnrollmentUrl('');
            }}
            onSuccess={onSuccessBasicDataForm}
          />
        )}
        {/* Little hack to reduce the space between the content and the footer */}
        <div className="md:-mb-80" />
        <MainFooter />
        {isIdle && !loadingUser && !me && (
          <ExitPopup
            title={t('EXIT_POPUP_TITLE')}
            subtitle={t('EXIT_POPUP_SUB_TITLE')}
            labelCta={t('EXIT_POPUP_CTA')}
            isRenderedIn="Landing Free Course Of The Day"
          />
        )}
      </div>
    </div>
  );
};

export default App;
